'use client';

import { log } from '@logtail/next';
import { Button } from "flowbite-react";
import StyledSpinner from "app/components/StyledSpinner";
import { getVideoDownloadLink } from "./ServerActions";
import { useState } from 'react';
import { Tooltip } from 'flowbite-react';
import { PiDownloadSimple } from "react-icons/pi";
import { AnimationDisplayData } from 'app/animate/[[...id]]/animate-utils';


type DownloadLinksProps = {
    displayData: AnimationDisplayData
}

export default function DownloadLinks({ displayData }: DownloadLinksProps) {

    
    const { id, displayName, videos, videoBase, readyFrames } = displayData;

    const [isDownloadingFrames, setIsDownloadingFrames] = useState(false);
    const [downloadingFramesProgress, setDownloadingFramesProgress] = useState(0);

    const showDownloadVideoButton = videos.length > 0;
    const showDownloadFramesButton = readyFrames > 0;

    const handleVideoDL = async () => {
        try {
            const vidLink = await getVideoDownloadLink(id, displayName, videos, videoBase);
            window.location.href = vidLink;
        } catch (error) {
            log.error("Failed to get video download link", { error })
        }
    }

    const handleFramesDL = async () => {
        setIsDownloadingFrames(true);
        try {
            const response = await fetch('/api/allframes/' + id);
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }
            if (!response.body) {
                throw new Error(`No frames found`);
            }

            const reader = response.body.getReader();

            let receivedLength = 0;
            const chunks = []; // Array to hold chunks

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    break;
                }
                chunks.push(value);
                receivedLength += value.length;
                setDownloadingFramesProgress(Math.min(Math.round((receivedLength / (17 * 1024 * 1024)) * 100), 100));
            }
            const blob = new Blob(chunks);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `[deforum]_${displayName}_frames.zip`; // Set the file name
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            setDownloadingFramesProgress(100);
        } catch (error) {
            log.error("Failed to get video download link", { error })
        } finally {
            setIsDownloadingFrames(false);
        }
    }

    return <div className='flex flex-row gap-2 justify-center'>
        {showDownloadVideoButton && 
            <Tooltip content={"Download your video"}>
                <Button
                    className="rounded-none border border-neutral-400 dark:border-neutral-400 bg-transparent text-black dark:text-white hover:scale-x-110 hover:ease-linear hover:duration-300"
                    size={'xs'}
                    onClick={() => void handleVideoDL()}>
                    <PiDownloadSimple className='inline mr-2' /> video
                </Button>
            </Tooltip>
        }
        {showDownloadFramesButton && 
            <Tooltip content={"Download all available frames as a zip file"}>
                <Button className="rounded-none border border-neutral-400 dark:border-neutral-400 bg-transparent text-black dark:text-white hover:scale-x-110 hover:ease-linear hover:duration-300"
                    size={'xs'}
                    onClick={() => void handleFramesDL()}>
                    {
                        isDownloadingFrames
                            ? <><StyledSpinner size={'sm'} className='inline mr-1' />Preparing frames ({downloadingFramesProgress}%)</>
                            : downloadingFramesProgress === 100
                            ? "Done. Check your downloads."
                            : <><PiDownloadSimple className='inline mr-1' />  frames</>
                    }
                </Button>
            </Tooltip>
        }
    </div>
}

